import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'CHILD_PROFILE/HOLIDAY_RSVP';

export const {
    action: fetch,
    success: fetchSuccess,
    failed: fetchFailed,
    aborted: fetchAborted,
} = createAction(
    `${domain}/FETCH`,
    (childId, vacationId) => ({childId, vacationId}),
    (vacation, replies, openingHours, isPreciseRSVPEnabled, allowedHours) => ({
        vacation,
        replies,
        openingHours,
        isPreciseRSVPEnabled,
        allowedHours,
    }),
);

export const {
    action: update,
    success: updateSuccess,
    failed: updateFailed,
} = createAction(
    `${domain}/UPDATE`,
    (vacationId, dayMaps) => ({vacationId, dayMaps}),
    (childIds, vacationId) => ({childIds, vacationId}),
);

export const {action: toggleRow} = createAction(`${domain}/TOGGLE_ROW`, index => ({index}));
